import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageSEO from '@/components/feature/PageSEO';
import Hero from './components/Hero';
import HotUpdateGrid from './components/HotUpdateGrid';
import CategoryRankSlider from './components/CategoryRankSlider';
import EditorPick from './components/EditorPick';
import AboutPreview from './components/AboutPreview';
import CTASection from './components/CTASection';
import Testimonials from './components/Testimonials';

const homeFAQItems = [
  {
    question: '古风漫画网是免费的吗？',
    answer: '是的，古风漫画网上的所有韩国漫画均为免费在线阅读，无需付费即可畅享海量精品内容。我们提供高清画质和流畅的下拉式阅读体验。',
  },
  {
    question: '需要下载APP才能看漫画吗？',
    answer: '不需要下载任何APP。古风漫画网完美适配电脑、平板、手机全终端，只需使用浏览器即可流畅阅读。我们特别为移动端优化了下拉式阅读体验，随时随地畅读无阻。',
  },
  {
    question: '漫画更新频率如何？',
    answer: '我们每日同步韩网最新更新，热门作品基本实现实时同步连载。每周新增超过200话全新内容，确保你追更零时差，永远走在剧情最前线。',
  },
  {
    question: '古风漫画网有什么特色？',
    answer: '古风漫画网以独特的古风审美视角甄选韩漫作品，不仅涵盖古风武侠、言情、玄幻等多元类型，还在画风、故事、意境上注重东方美学基因的表达。同时我们采用流畅的下拉式阅读模式，为用户带来沉浸式的阅读体验。',
  },
];

export default function Home() {
  return (
    <>
      <Navbar />
      <PageSEO
        type="home"
        breadcrumbItems={[{ label: '首页' }]}
        faqItems={homeFAQItems}
      />
      <main>
        <Hero />
        <HotUpdateGrid />
        <CategoryRankSlider />
        <EditorPick />
        <AboutPreview />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}